export function formatTimestamp(ts) {
  if (!ts) return '';
  try {
    const d = typeof ts === 'number' ? new Date(ts) : new Date(ts);
    if (isNaN(d.getTime())) return String(ts);
    return d
      .toISOString()
      .replace('T', ' ')
      .replace('Z', '');
  } catch (e) {
    return String(ts);
  }
}

export function truncate(s, n) {
  if (!s) return '';
  return s.length > n ? `${s.substring(0, n)}...` : s;
}

export function formatEventsForClipboard(events, anchorId) {
  if (!events || events.length === 0) return '';

  return events
    .map((evt) => {
      const isAnchor = evt['@id'] === anchorId;
      const prefix = isAnchor ? '[ANCHOR] ' : '';
      const ts = formatTimestamp(evt['@timestamp'] || evt.time || '');
      const level = evt.Level || evt.level || evt.loglevel || '';
      const header = `${prefix}--- ${[ts, level]
        .filter(Boolean)
        .join('  ')} ---`;

      return `${header}\n${JSON.stringify(evt, null, 2)}`;
    })
    .join('\n\n');
}
